// eslint-disable-next-line import/prefer-default-export
export const FOOTER_HEIGHT = 180;
